import { Button, CircularProgress } from "@mui/material";
import React, { JSX } from "react";
import styled from "styled-components";
import { Spacing } from "../../config";

import { useFormFull } from "form-full";
import FontStyles from "../styles/fontStyles";
interface StyledCircularProgressProps {
  $show: boolean;
}
const StyledButton = styled(Button)(({ theme }) => {
  const { palette: colors, spacing } = theme;
  return {
    "&&.MuiButton-root": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: Spacing(0.85, 1.75),
      marginTop: Spacing(0.75),
      flexShrink: 0,
      overflow: "hidden",
      color: colors.text.primary,
      borderColor: colors.text.primary,
      borderWidth: Spacing(0.3),
      textTransform: "uppercase",

      ...FontStyles.medium16,
    },

    "&&.MuiButton-startIcon": {
      fill: "blue",
      width: 17,
    },
  };
});
const StyledCircularProgress = styled(CircularProgress)<StyledCircularProgressProps>(({ theme, $show }) => {
  const { palette: colors } = theme;
  return {
    position: "absolute",
    color: colors.text.secondary,
    transition: ".5s",
    opacity: $show ? 1 : 0,
  };
});

const ChildrenContainer = styled.div<StyledCircularProgressProps>(({ $show }) => {
  return {
    transition: ".5s",
    opacity: $show ? 1 : 0.5,
  };
});
interface Props {
  fullWidth?: boolean;
  label?: string;
  children?: React.ReactNode;

  disabled?: boolean;
  loading?: boolean;
  name?: string;
  feedback?: boolean;
  action?: "submit" | "clear" | "clearDefault";

  onClick?: (event: any) => void;

  [key: string]: any;
}
function ButtonTextComponent({
  fullWidth = true,
  label,
  children,

  disabled,
  loading,
  name,
  feedback,
  action,

  onClick: onClickProps,
  ...props
}: Props): JSX.Element {
  const { onClick, formLoading, formDisabled } = useFormFull.button({
    feedback,
    action,
    onClick: onClickProps,
  });
  const isLoading = !!(loading || formLoading);
  return (
    <StyledButton
      variant="outlined"
      loading={loading || formLoading}
      disabled={disabled || formDisabled}
      fullWidth={fullWidth}
      onClick={onClick}
      {...props}
    >
      <StyledCircularProgress size={Spacing(3)} $show={isLoading} />
      <ChildrenContainer $show={!isLoading}>
        {label ? label : children}
      </ChildrenContainer>
    </StyledButton>
  );
}

export default ButtonTextComponent;
